import React, { useState } from 'react';

import { Grid, InputLabel, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import PopupConfirmDialog from '../../../components/popupConfirmDialog';

const BookingDocument = ({ document, onDelete, onDownload, showDelete }) => {

	const [showDialog, setShowDialog] = useState(false);

  const fileSize = (size) => { 
    return size < 1024 ? `${size}B` :
           (size < 1048576 ? `${(size / 1024).toFixed(2)}KB` : `${(size / 1048576).toFixed(2)}MB`);
  }

	return (
		<Grid className="document-row" container item sm={12} xs={12}>
      <Grid item sm={4} xs={4}>
        <InputLabel shrink >
          { document.filename }
        </InputLabel>
      </Grid>
      <Grid item sm={3} xs={3}>
        <InputLabel shrink >
          { fileSize(document.byte_size) }
        </InputLabel>
      </Grid>
      <Grid item sm={4} xs={4}>
        <InputLabel shrink >
          { document.content_type }
        </InputLabel>
      </Grid>
      <Grid item sm={1} xs={1}>
	      { showDelete && (
	      	<IconButton aria-label="delete" color="secondary" 
	            onClick={ () => setShowDialog(true) } >
	          <DeleteIcon fontSize="small" />
	        </IconButton>
	        )
        }
        <PopupConfirmDialog open={showDialog} 
          labels={
            {
              title: 'Eliminar documento',
              message: `¿Desea eliminar el documento ${document.name}?`,
              confirmLabel: 'Si',
              closeLabel: 'No'
            }
          }
          onClose={ () => setShowDialog(false) }
          onConfirm={() => { setShowDialog(false); onDelete(document.id) }
          }
        />
        <IconButton aria-label="download" color="secondary" onClick={ () => onDownload(document)} >
          <GetAppIcon fontSize="small" />
        </IconButton>
      </Grid>
    </Grid>
	);
}

export default BookingDocument;
